import React, { Component } from "react";
import Modal from "../../../UIComponents/CustomModal/Modal";
import { Segment } from "semantic-ui-react";

import "./PostInfoModal.css";

class PostInfoModal extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <Modal className={`post-info-modal`} show={this.props.open} onClose={() => this.props.hideModal()}>
                <Modal.Header>POST KEYWORDS</Modal.Header>
                <Modal.Content>
                    {this.props.apiStatus === "pending" && <div className="info"> loading data ... </div>}
                    {this.props.apiStatus === "rejected" && <div className="info"> Unable to fetch the data at moment </div>}

                    {this.props.isTrial == "1" && (
                        <div>Full / Paid accounts will see details of the configured query here. This feature is not enabled for trial accounts.</div>
                    )}

                    {this.props.data && (
                        <div>
                            <div className="post-id">
                                {" "}
                                CID: <span>{this.props.data.post_id}</span>{" "}
                            </div>
                            <div className="post-info">
                                {this.props.data.accounts && this.props.data.accounts.length > 0 && (
                                    <div className="accounts">
                                        <section className="heading"> KEYWORDS </section>
                                        <div>
                                            {this.props.data.accounts.map((acc) => (
                                                <span key={acc.id}> {JSON.parse(acc.details).keywords[0]} </span>
                                            ))}
                                        </div>
                                    </div>
                                )}
                                {this.props.data.factiva && this.props.data.factiva.length > 0 && this.props.platformName == "LexisNexis" && (
                                    <div className="factiva">
                                        <section className="heading"> LEXISNEXIS </section>
                                        <div>
                                            {this.props.data.factiva.map((fct) => (
                                                <span key={fct}> {fct} </span>
                                            ))}
                                        </div>
                                    </div>
                                )}
                                {this.props.data.booleans &&
                                    this.props.data.booleans.length > 0 &&
                                    this.props.data.booleans.map((bool) => (
                                        <Segment vertical key={bool.id}>
                                            <section className="heading">
                                                <div>
                                                    {" "}
                                                    TOPIC: <span className="bold-yellow"> {bool.topic_name} </span>{" "}
                                                </div>
                                                <div>
                                                    {" "}
                                                    SUBTOPIC: <span className="bold-yellow"> {bool.subtopic_name} </span>{" "}
                                                </div>
                                            </section>
                                            <div className="created-date">
                                                {" "}
                                                CREATED DATE: <span>{new Date(bool.created_date).toGMTString()}</span>{" "}
                                            </div>
                                            <section className="content">{bool.details}</section>
                                        </Segment>
                                    ))}
                            </div>
                        </div>
                    )}
                </Modal.Content>
            </Modal>
        );
    }
}

export default PostInfoModal;
